function highlight(text, positions) {
  if (typeof positions === "undefined") {
    return text;
  }
  let newText = text;
  const open = `<mark className="tds-highlight">`;
  const close = `</mark>`;
  positions.forEach((position, idx) => {
    const {
      length,
      offset
    } = position;
    const insertOffset = offset + (open.length + close.length) * idx;
    const beginning = `${newText.slice(0, insertOffset)}`;
    const highlightedText = `${newText.slice(insertOffset, insertOffset + length)}`;
    const end = `${newText.slice(insertOffset + length)}`;
    newText = `${beginning}${open}${highlightedText}${close}${end}`;
  });
  return newText;
}

export { highlight as default };
